// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2TdVl","colMaxWidth":"Table_colMaxWidth__3plQK"};